import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'

import Screener from './components/Screener.vue'
import ScreenerEmail from './components/ScreenerEmail.vue'
import ScreenerQuestions from './components/ScreenerQuestions.vue'
import ScreenerReport from './components/ScreenerReport.vue'
import ScreenerPlan from './components/ScreenerPlan.vue'
import ScreenerToYoung from './components/ScreenerToYoung.vue'

Vue.use(Router)

export default new Router({
    base: process.env.NODE_ENV === 'production' ? '/screener/' : '/',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        }, {
            path: '/screener',
            name: 'screener',
            component: Screener,
            children: [{
                path: ':group/:question',
                name: 'questions',
                component: ScreenerQuestions
            }, {
                path: 'email',
                name: 'email',
                component: ScreenerEmail
            }, {
                path: 'report',
                name: 'report',
                component: ScreenerReport
            }, {
                path: 'to-young',
                name: 'to-young',
                component: ScreenerToYoung
            }]
        },
        {
            path: '/plan',
            name: 'plan',
            component: ScreenerPlan
        }
    ]
})
